import Vue from 'vue';
import VueRouter from 'vue-router';
import ErrorComponent from '@/components/common/AsyncError';

const Dashboard = () => ({
  component: import('@/containers/Dashboard'),
  error: ErrorComponent,
  timeout: 5000,
});

const Management = () => ({
  component: import('@/containers/Management'),
  error: ErrorComponent,
  timeout: 5000,
});

const SingleDevicePage = () => ({
  component: import('@/containers/DeviceSinglePage'),
  error: ErrorComponent,
  timeout: 5000,
});

const GraphicalViewer = () => ({
  component: import('@/components/editor/GraphicalViewer'),
  error: ErrorComponent,
  timeout: 5000,
});

const Editor = () => ({
  component: import('@/containers/Editor'),
  error: ErrorComponent,
  timeout: 5000,
});

const TestRequest = () => ({
  component: import('@/containers/TestRequest'),
  error: ErrorComponent,
  timeout: 5000,
});

/*
const Modbus = () => ({
  component: import('@/containers/Modbus'),
  error: ErrorComponent,
  timeout: 5000,
});
*/

/*
const TestAPI = () => ({
  component: import('@/containers/TestAPI'),
  error: ErrorComponent,
  timeout: 5000
}) */
// import { ProgressBar } from '@/js/plugin'
// const Dashboard = () => import('@/containers/Dashboard')
// import Management from '@/containers/Management'
// import store from '@/store'
// import SingleDevicePage from '@/containers/DeviceSinglePage'
// const SingleDevicePage = resolve => require(['@/containers/DeviceSinglePage'], resolve);
//  const Management = () => import('@/containers/Management')
// const Documentation = () => import('@/containers/Document')
// const SingleDevicePage = () => import('@/containers/DeviceSinglePage')
// import MarkDown from '@/markdowns/document.md'

Vue.use(VueRouter);
// Vue.use(ProgressBar);

const router = new VueRouter({
  mode: 'history',
  base: '',
  routes: [
    /*
    {
      path: '/testapi',
      name: 'testAPI',
      component: TestAPI
    }, */
    {
      path: '/dashboard',
      name: 'dashboardPage',
      component: Dashboard,
      children: [
        {
          path: '/dashboard/:deviceMAC',
          name: 'singleDashboard',
          component: SingleDevicePage,
          meta: { fullScreen: true },
          children: [
            {
              meta: { fullScreen: true },
              path: ':portId',
            },
          ],
        },
      ],
    },
    {
      path: '/management',
      name: 'managementPage',
      component: Management,
      children: [
        {
          path: '/management/pref',
          name: 'userPreferences',
        },
      ],
    },
    /*
    {
      path: '/maker',
      name: 'makerPage',
      component: Maker
    },
    */
    {
      path: '/studio',
      name: 'studioPage',
      component: Editor,
      children: [
        {
          path: '/studio/:viewId',
          name: 'viewPage',
          component: GraphicalViewer,
          meta: { fullScreen: true, isView: true },
        },
        {
          path: '/studio/editor/:viewId',
          name: 'editorPage',
        },
        {
          path: '/studio/viewer/:viewId',
          name: 'viewerPage',
          component: GraphicalViewer,
          meta: { fullScreen: true, viewerMode: true, isView: true },
        },
      ],
    },
    {
      path: '/testrequest',
      name: 'testRequest',
      component: TestRequest,
    },
    /*
    {
      path: '/modbus',
      name: 'modbusPage',
      component: Modbus,
    },
    */
    /*
    {
      path: '/documentation',
      name: 'documentPage',
      component: Documentation
    },
    */
    /* {
      path: '/markdown',
      name: 'markDown',
      component: MarkDown,
    }, */
    /*
    {
      path: '/device/:deviceId',
      name: 'deviceView',
      component: SingleDevicePage,
      beforeEnter: (to, from, next) => {
        var deviceId = to.params.deviceId;
        var deviceList = store.getters['device/deviceData'];
        // console.log(deviceId, deviceList)
        if (deviceList instanceof Array && deviceList.filter(dev => dev.dev_host_id === deviceId).length) next();
        else next('/device');
      }
    },
    */
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (
    !/\/dashboard\/./.test(to.fullPath) &&
    !/\/dashboard\/./.test(from.fullPath) &&
    !(to.path === from.path)
  ) {
    Vue.prototype.$progressBar.show();
  }
  next();
});

router.afterEach(() => {
  Vue.prototype.$progressBar.hide();
});

export default router;
